<template>
	<div class="page">
		<div
			class="container-fluid"
			id="foot"
		>
			<div class="container footer-box">
				<div class="fl1">
					<!-- <div>盛世创客（成都）人力资源管理有限公司</div> -->
					<!-- <p>地址：成都市武侯区致名路34号附25号1栋1层002号</p> -->
					<!-- <p>电话：13811132498</p> -->
					<!-- <div class="code">
						<div class="codebox">
							<img src="@/assets/image/code1.jpg" />
							<p>小程序</p>
						</div>
						<div class="codebox">
							<img src="@/assets/image/app_code.png" />
							<p>App</p>
						</div>
					</div> -->
					<div class="each-icon">
						<img src="@/assets/home/-h-btm_advance_icon_01.png" alt="" srcset="">
						<div class="info">
							<div class="name">AI智能面试</div>
							<div class="desc">提供高效招聘流程</div>
						</div>
					</div>
					<div class="each-icon">
						<img src="@/assets/home/-h-btm_advance_icon_02.png" alt="" srcset="">
						<div class="info">
							<div class="name">全方位保障</div>
							<div class="desc">确保招聘质量、降低潜在风险</div>
						</div>
					</div>
					<div class="each-icon">
						<img src="@/assets/home/-h-btm_advance_icon_03.png" alt="" srcset="">
						<div class="info">
							<div class="name">高效的招聘</div>
							<div class="desc">招聘流程变得更加高效和便捷</div>
						</div>
					</div>
					<div class="each-icon">
						<img src="@/assets/home/-h-btm_advance_icon_04.png" alt="" srcset="">
						<div class="info">
							<div class="name">人才库</div>
							<div class="desc">精准匹配，快速找到合适的人选</div>
						</div>
					</div>
				</div>

				<div class="fl2">
					<!-- <div class="mid">
						<div>企业介绍</div>
						<a href="/list4.html">品牌介绍</a>
						<a href="/list4.html">团队介绍</a>
						<a href="/list4.html">关于我们</a>
					</div> -->

					<div class="contact">
						<img src="@/assets/home/-h-footer_logo.png" alt="">
					</div>
					<!-- <div class="contact">
						<div>关于我们</div>
						<ul>
							<li class="ft1" @click="$router.push('/template')">产品介绍</li>
							<li class="ft2" @click="$router.push('/list3.html')">服务介绍</li>
							<li class="ft2" @click="$router.push('/list2.html')">加入我们</li>
						</ul>
					</div> -->
					<div class="contact">
						<div  class="mb-10">进入产品</div>
						<ul>
							<li class="ft1" @click="$router.push('/allTabs/interview')">AI面试</li>
							<!-- <li class="ft2" @click="$router.push('/list3.html')">人才管理</li> -->
							<!-- <li class="ft2" @click="$router.push('/list2.html')">校招</li>
							<li class="ft2" @click="$router.push('/list2.html')">社招</li> -->
							<li class="ft2" @click="$router.push('/allTabs/employment')">就业舱</li>
						</ul>
					</div>
					<div class="contact">
						<div  class="mb-10">解决方案</div>
						<ul>
							<!-- <li class="ft1" @click="$router.push('/template')">AI面试</li>
							<li class="ft2" @click="$router.push('/list3.html')">人才招聘</li>
							<li class="ft2" @click="$router.push('/list2.html')">政府行业就业</li>
							<li class="ft2" @click="$router.push('/list2.html')">退伍军人就业</li>
							<li class="ft2" @click="$router.push('/list2.html')">搞笑行业就业</li> -->
							<li class="ft2" @click="$router.push('/allTabs/example')">案例展示</li>
						</ul>
					</div>
					<div class="contact">
						<div  class="mb-10">服务与支持</div>
						<ul>
							<!-- <li class="ft1" @click="$router.push('/template')">常见问题</li>
							<li class="ft2" @click="$router.push('/list3.html')">隐私条款</li>
							<li class="ft2" @click="$router.push('/list2.html')">服务协议</li> -->
							<li class="ft2" @click="dialogVisible = true">客服中心</li>
						</ul>
					</div>
					<div class="contact">
						<div class="mb-10">联系我们</div>
						<ul>
							<li class="ft1">咨询电话：15117959223</li>
							<li class="ft2">合作邮箱：yangyong@hrclass.com.cn</li>
							<li class="ft2">公司地址：成都市天府新区天府大道2039号天府菁蓉大厦209室</li>
							<li class="ft3">
								<div>
									<img src="@/assets/code.jpg" alt="" srcset="">
									关注我们
								</div>
								<div>
									<img src="@/assets/xcx.jpg" alt="" srcset="">
									小程序
								</div>
								<div>
									<img src="https://img.hrclass.com.cn/ai/img/202410311841-01.png" alt="" srcset="">
									下载app
								</div>
							</li>
						</ul>
					</div>
					<!-- <div class="contact">
						<div>服务范围</div>
						<ul>
							<li class="ft1" @click="$router.push('/template')">产品介绍</li>
							<li class="ft2" @click="$router.push('/list3.html')">热招岗位</li>
							<li class="ft2" @click="$router.push('/list2.html')">学员案例</li>
						</ul>
					</div> -->
				</div>
			</div>
		</div>
		<footer class="container-fluid">
			<div class="text-center h-30">
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">© 2022-2024 AI面试易 版权所有</a>
				
				<!-- <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">服务协议</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">隐私政策</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">其他政策</a> -->
			</div>
			<div class="text-center  h-30">
				<img src="@/assets/1.png" alt="" srcset="" class="w-20 inline-block  ">
				<a href="https://beian.miit.gov.cn/"
				target="_blank">蜀ICP备2021001179号-1</a></div>
			<!-- <div>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">蜀ICP备2021001179号-1</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">营业执照</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">人力资源服务许可证</a>
				<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
				target="_blank">网上有害信息举报专区</a>
			</div> -->
			<!-- <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow"
        >蜀ICP备2021001179号</a
      > -->
		</footer>
   <!-- 联系我们窗口 -->
   <el-dialog  class="mtDialog" :visible.sync="dialogVisible" width="600px"  :show-close="false">
	<div class="flex items-center pt-30 justify-between">
                <div class="text-[16px]  text-[#000000] font-semibold ">联系我们</div>
                <img src="@/assets/tab-4/btn_close@2x.png" alt="" class="w-20 h-20 " @click="dialogVisible = false">
            </div>
            <div class="flex justify-between pb-20 mt-30">
                <div class="flex justify-between w-full">
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-100 rounded-[10px]">
                        <img src="@/assets/tab-4/icon_phone@2x.png" alt="" class="w-25 h-25">
                        <div class="mt-13 text-[#222222] text-[14px] font-semibold">合作咨询电话</div>
                        <div class="mt-13 text-[#666666] text-[18px] font-normal">15117959223</div>
                    </div>
                    <div class="bg-[#F4FCFF] pt-17 pl-21 pb-23 pr-20  rounded-[10px] flex ">
                        <div>
                            <img src="@/assets/tab-4/icon_scan@2x.png" alt="" class="w-25 h-25">
                            <div class="mt-13 text-[#222222] text-[14px] font-semibold">添加企业微信顾问</div>
                            <div class="mt-13 text-[#666666] text-[18px] font-normal">为您详细解答</div>
                        </div>
                        <img src="@/assets/tab-4/2.jpg" alt="" class="w-95 h-95 ml-20 ">
                    </div>
                </div>
            </div>
            <div class="bg-[#F4FCFF] pt-20 pl-21 pb-23 pr-20  rounded-[10px]  ">
                <div>
                    <img src="@/assets/tab-4/icon_scan@2x.png" alt="" class="w-25 h-25">
                    <div class="mt-13 text-[#222222] text-[14px] font-semibold">联系地址</div>
                    <div class="mt-13 text-[#666666] text-[18px] font-normal">成都市天府新区天府大道2039号天府菁蓉大厦209室</div>
                </div>
            </div>
            
        </el-dialog>
		
	</div>
</template>

<script>
export default {
	data(){
	return{
		dialogVisible:false
	}
	}
};
</script>

<style
	lang="less"
	scoped
>
.mtDialog{
    border-radius: 20px;
    ::v-deep.el-dialog{
        border-radius: 10px;
    }
    ::v-deep.el-dialog__header {
    padding: 0px 20px!important;
}
::v-deep.el-dialog__body{
    padding: 0px 20px 20px 20px!important;
}

}
.page{
	background: #eee;
}
.container-fluid {
	width: 1200px;
	margin: 0 auto;
}
/* 版心 */
.container {
	width: 1200px;
	margin: 0 auto;
}
#foot {
	padding: 20px 0;
	border-bottom: 1px solid #DDDDDD;
}

#foot .fl1 {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #DDDDDD;
	padding: 15px 0 30px;
	.each-icon{
		display: flex;
		align-items: center;
		font-weight: 600;
		font-size: 14px;
		color: #222222;
		img{
			width: 45px;
			margin-right: 12px;
		}
		.desc{
			font-weight: normal;
			color: #666666;
			line-height: 20px;
		}
	}
}
#foot .fl2 {
	margin: 40px auto 80px;
	display: flex;
	justify-content: space-between;
	.contact{
		font-weight: 600;
		font-size: 14px;
		color: #222222;
		line-height: 20px;
		img{
			width: 106px;
		}
		li {
			height: 30px;
			list-style: none;
			cursor: pointer;
			font-weight: 400;
			color: #666666;
			line-height: 34px;
		}
		.ft3{
			display: flex;
			justify-content: space-between;
			div{
				img{
					width: 94px;
					height: 94px;
				}
				color: #222222;
				font-size: 14px;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
		}
	}
}

#foot .mid {
	width: 100px;
	margin-left: 40px;
	float: left;
}

#foot .mid div {
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 15px;
}

#foot .mid a {
	display: block;
	font: 12px/30px "微软雅黑";
}

#foot .code {
	display: flex;

	font-size: 12px;
	margin-top: 40px;
	color: #fff;
	.codebox {
		width: 120px;

		margin-right: 30px;
		p {
			text-align: center;
		}
	}
}

#foot .code img {
	display: block;
	width: 100%;
	height: 120px;
	margin-bottom: 4px;
	margin-right: 14px;
}

footer {
	background: #EFEFEF;
	color: #fff;
	font-size: 14px;
	overflow: hidden;
	padding: 18px 0;
	div{
		margin: 5px 0;
	}
	a {
		color: #666;
		margin-right: 43px;
	}
}
</style>
